import React from 'react';

import { Form, FormikProvider, useFormik } from 'formik';

import { useAuth } from 'modules/authentication/presentation/contexts';
import { MandatoryPhoneSchema } from 'modules/authentication/presentation/validations';
import { Modal } from 'shared/presentation/components/atoms';
import {
  Button,
  FullPageLoading,
  TextInput,
} from 'shared/presentation/components/molecules';
import { ICONS, MASKS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';
import { useMediaQuery } from 'shared/presentation/hooks';

import { useMandatoryPhoneGate } from './hooks';
import * as S from './styles';
import LisaImage from '../../../assets/lisa.png';

const MandatoryPhoneGate: React.FC = ({ children }) => {
  const { t, sharedT, language } = useLocale('authentication');
  const isMobile = useMediaQuery('md');

  const auth = useAuth();
  const gate = useMandatoryPhoneGate();

  const formik = useFormik({
    initialValues: { phone: '' },
    validationSchema: MandatoryPhoneSchema({ t, sharedT, language }),
    onSubmit: values => gate.updatePhone(values.phone),
  });

  if (gate.loading) return <FullPageLoading />;

  if (!gate.shouldBlock) return <>{children}</>;

  return (
    <Modal
      initialOpen
      closeOnOverlayClick={false}
      align={isMobile ? 'bottom' : 'center'}
    >
      <S.Container>
        <img src={LisaImage} alt="Lisa" />

        <header>
          <h2>{t('Hello, friend!')}</h2>
          <p>
            {t(
              'We could not find your cellphone number through your social login',
            )}
          </p>
          <p>{t('Please fill in the field below to continue browsing')}</p>
        </header>

        <FormikProvider value={formik}>
          <Form>
            <TextInput
              name="phone"
              label={t('Phone')}
              placeholder={t('PHONE_PLACEHOLDER')}
              mask={MASKS.PHONE[language]}
              icon={ICONS.PHONE}
            />

            <Button
              variant="primary"
              type="submit"
              disabled={!formik.isValid}
              loading={gate.updating}
            >
              {t('Continue')}
            </Button>
          </Form>
        </FormikProvider>

        <Button
          variant="default"
          type="button"
          outline
          icon={ICONS.LOG_OUT}
          onClick={() => auth.logout()}
        >
          {t('Log out and identify yourself again')}
        </Button>
      </S.Container>
    </Modal>
  );
};

export default MandatoryPhoneGate;
